// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import IdcardOutlinedSvg from "@fishx/icons-svg/es/asn/IdcardOutlined";
import FishxIcon from '../components/FishxIcon';

var IdcardOutlined = function IdcardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: IdcardOutlinedSvg
  }));
};

IdcardOutlined.displayName = 'IdcardOutlined';
export default React.forwardRef(IdcardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/IdcardOutlined.js
// module id = 2949
// module chunks = 0